/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timestamp claims (UTC)`)
};

const es_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamaciones de marca de tiempo (UTC)`)
};

const de_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitstempel-Claims (UTC)`)
};

const nl_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timestamp claims (UTC)`)
};

const fr_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revendications d'horodatage (UTC)`)
};

const it_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivendicazioni di timestamp (UTC)`)
};

const pt_br2_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicações de timestamp (UTC)`)
};

const pt_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicações de marcação de tempo (UTC)`)
};

const ja_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムスタンプクレーム（UTC）`)
};

const zh_jw_claims_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间戳声明（UTC）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_claims_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_claims_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_claims_title", locale)
	if (locale === "en") return en_jw_claims_title(inputs)
	if (locale === "es") return es_jw_claims_title(inputs)
	if (locale === "de") return de_jw_claims_title(inputs)
	if (locale === "nl") return nl_jw_claims_title(inputs)
	if (locale === "fr") return fr_jw_claims_title(inputs)
	if (locale === "it") return it_jw_claims_title(inputs)
	if (locale === "pt-BR") return pt_br2_jw_claims_title(inputs)
	if (locale === "pt") return pt_jw_claims_title(inputs)
	if (locale === "ja") return ja_jw_claims_title(inputs)
	return zh_jw_claims_title(inputs)
};